import React, { useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useForm } from 'react-hook-form';
import { UnitFragment } from '../../../generated/graphql';

interface EditUnitDialogProps {
  open: boolean;
  unit: UnitFragment;
  loading?: boolean;
  onClose: () => void;
  onSubmit: (data: FormFields) => void;
}

interface FormFields {
  name: string;
  address: string;
  description: string;
  note: string;
}

export function EditUnitDialog(props: EditUnitDialogProps) {
  const { open, unit, loading = false, onClose, onSubmit } = props;

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormFields>({
    defaultValues: {
      name: unit.name ?? '',
      address: unit.address ?? '',
      description: unit.description ?? '',
      note: unit.note ?? '',
    },
  });

  useEffect(() => {
    if (open) {
      reset({
        name: unit.name ?? '',
        address: unit.address ?? '',
        description: unit.description ?? '',
        note: unit.note ?? '',
      });
    }
  }, [open, unit, reset]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle>Upraviť nehnuteľnosť</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            required
            error={!!errors.name}
            helperText={errors.name?.message}
            label="Názov"
            {...register('name', { required: 'Názov je povinný' })}
            fullWidth
            variant="standard"
            margin="normal"
            disabled={loading}
          />
          <TextField
            label="Adresa"
            {...register('address')}
            fullWidth
            variant="standard"
            margin="normal"
            disabled={loading}
          />
          <TextField
            label="Poznámka"
            {...register('note')}
            fullWidth
            variant="standard"
            margin="normal"
            multiline
            minRows={3}
            disabled={loading}
          />
          <TextField
            label="Opis nehnuteľnosti"
            {...register('description')}
            fullWidth
            variant="standard"
            margin="normal"
            multiline
            minRows={3}
            disabled={loading}
          />
        </DialogContent>
        <DialogActions>
          <Button type="button" onClick={onClose} disabled={loading}>
            Zrušiť
          </Button>
          <Button type="submit" variant="contained" disabled={loading}>
            Uložiť
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
